import { Store } from '../../../../../types/store';

export const formatContentfulData = (nearestStoreId: Store['Id']) => {
    const replaceStoreLink = (anchorLink: Element) => {
        anchorLink.setAttribute('href', nearestStoreId ? `/stores/${nearestStoreId}` : '/stores');
        anchorLink.setAttribute('rel', 'noreferrer');
    };
    const answer = document.querySelector('.answer');
    if (!answer) return;

    const linkElements = answer.querySelectorAll('a') || null;
    linkElements.forEach((link) => {
        // Replace any 'your store' links with actual user's set store from cookies
        if (nearestStoreId && link.innerHTML == 'your store') {
            replaceStoreLink(link);
        }
        // Ensure all links open in a new tab, Contentful doesn't allow link attributes to be set.
        link.setAttribute('target', '_blank');
    });
    //Add manual linebreaks as they aren't supported by or included with Contentful
    const allParagraphs = answer.getElementsByTagName('p');
    Array.from(allParagraphs).forEach((element) => {
        if (element.innerText == '') {
            const breakline = document.createElement('br');
            element.insertAdjacentElement('beforebegin', breakline);
        }
    });

    // Request from UX writing to have long lists in a column layout. Contentful only offers tables so setting a CSS classname for columns.
    const ulElements = answer.getElementsByTagName('ul');
    if (ulElements) {
        Array.from(ulElements).forEach((element) => {
            if (element.children.length > 10) {
                element.classList.add('format-columns');
            }
        });
    }
};
